type KeysRewardsRankLoyalty =
  | "mascotId"
  | "boosterId"
  | "rewardNominalId"
  | "rewardFreeSpinId"
  | "rewardCashbackDailyId"
  | "rewardCashbackWeeklyId"
  | "rewardCashbackMonthlyId";

export const LOYALTY_REWARDS_KEYS: Record<KeysRewardsRankLoyalty, string> = {
  mascotId: "loyalty.reward.newAvatar",
  boosterId: "loyalty.reward.booster",
  rewardNominalId: "loyalty.reward.cashBonus",
  rewardFreeSpinId: "loyalty.reward.freeSpin",
  rewardCashbackDailyId: "loyalty.reward.dailyCashback",
  rewardCashbackWeeklyId: "loyalty.reward.weeklyCashback",
  rewardCashbackMonthlyId: "loyalty.reward.monthlyCashback",
};
